import { makeOrderConstants } from '../constants';

const makeOrder = (state, action) => {
    if (state === undefined) {
        return {
            data: {},
            loading: false,
            error: null,
            id: null,
            success: false,
        };
    }

    switch (action.type) {
        case makeOrderConstants.FETCH_MAKE_ORDER_REQUEST:
            return {
                data: {},
                loading: true,
                error: null,
                id: null,
                success: false,
            };

        case makeOrderConstants.FETCH_MAKE_ORDER_SUCCESS:
            return {
                data: action.payload,
                loading: false,
                error: null,
                id: action.id,
                success: true,
            };

        case makeOrderConstants.FETCH_MAKE_ORDER_FAILURE:
            return {
                data: {},
                loading: false,
                error: action.payload,
                id: null,
                success: false,
            };

        default:
            return state;
    }
};

export default makeOrder;
